//export const ENGINE_URL = 'engine.php'
// export var ENGINE_URL = 'http://localhost/adm/engine.php'
// export var GEMI_URL = 'http://localhost/adm/gemi.php'
export var ENGINE_URL = 'https://cocktail-4.e-menu.in.ua/adm/engine.php'
export var GEMI_URL = 'https://cocktail-4.e-menu.in.ua/adm/gemi.php'
//export const ENGINE_URL = 'http://192.168.0.2/adm/engine.php'
//export const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
//export var ENGINE_URL = 'https://cocktail-4.e-menu.in.ua/adm/engine.php'
// export var ENGINE_URL = "https://cocktail.local/cocktail-back/engine.php";
//export var ENGINE_URL = 'https://cocktail-4.e-menu.in.ua/adm/engine.php'
//export var ENGINE_URL = "https://cocktail.local/cocktail-back/engine.php"
if (process.env.NODE_ENV === 'production') ENGINE_URL = 'engine.php'
if (process.env.NODE_ENV === 'production') GEMI_URL = 'gemi.php'
